import script from "./h_check_page.vue?vue&type=script&lang=ts&setup=true"
export * from "./h_check_page.vue?vue&type=script&lang=ts&setup=true"

import "./h_check_page.vue?vue&type=style&index=0&id=f2f530fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2f530fe"]])

export default __exports__